import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Box, Button, Paper, Stack } from "@mui/material";
import Payforservice from "./components/payforservice";
import { Grid } from "@mui/material";
import CustomInput from "../../Components/CustomInput/CustomInput";
import Divider from "@mui/material/Divider";
import DefaultButton from "../../Components/CustomButtons/defaultButton";
import Withholding from "./components/withholding";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CustomTypeEditComponent = (props) => {
  const apiRef = useGridApiContext();
  const handleValueChange = async () => {
    console.log("handleValueChange", props);
    console.log("handleValueChange", props.row);
    console.log("handleValueChange", apiRef);

    // await apiRef.current.setEditCellValue({
    //     id: props.id,
    //     field: 'refReportoptiontype',
    //     value: '',
    // });
  };
  return (
    <GridEditSingleSelectCell onValueChange={handleValueChange} {...props} />
  );
};
CustomTypeEditComponent.propTypes = {
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default function Receiptwithholding(arg) {
  const { userData, mainrowsData } = arg;
  const [withholdingdefaultValue, setwithholdingdefaultValue] =
    React.useState(0);
  const [value, setValue] = React.useState(0);
  const [payforservicedata, setpayforservicedata] = React.useState([]);
  const [withholdingData, setwithholdingData] = React.useState([]);

  const [refdocno, setrefdocno] = React.useState(0);

  React.useEffect(() => {
    checkrefDocno();
    return () => {
      setrefdocno([]);
    };
  }, [mainrowsData]);

  const checkrefDocno = async () => {
    //  console.log("React.useEffect mainrowsData", mainrowsData)
    let docno = [];
    mainrowsData.forEach((element) => {
      if (
        element.T_Docdebt !== "" &&
        typeof element.T_Docdebt !== "undefined"
      ) {
        docno.push("'" + element.T_Docdebt + "'");
      }
    });
    await setrefdocno(docno);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onSubmit = () => {
    console.log("onSubmit");

    const newState = [];

    withholdingData.map((obj) => {
      // 👇️ if id equals 2, update country property
      if (obj.no !== "") {
        newState.push(obj);
      }
      //    // 👇️ otherwise return object as is
    });
    //console.log("submitClick", newState);

    arg.resdata(newState);

    arg.resdata(withholdingData);

    arg.receivedwithholdingdeData(withholdingdefaultValue);
  };
  const reswithholding = (e) => {
    console.log("res reswithholding", e);
    setwithholdingdefaultValue(e);
  };

  const resrowsData = (e) => {
    console.log("res resrowsData", e);
    setpayforservicedata(e);
  };
  const rswithholding = (e) => {
    console.log("res rswithholding", e);
    setwithholdingData(e);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="ชำระค่าบริการ" {...a11yProps(0)} />
            <Tab label="ภาษีหัก ณ ที่จ่าย" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Payforservice
            reswithholding={(e) => reswithholding(e)}
            resrowsData={(e) => resrowsData(e)}
            defaultrows={payforservicedata}
            refdocnos={refdocno}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Withholding
            payforservice={payforservicedata}
            defaultdata={payforservicedata}
            userData={userData}
            rswithholding={(e) => rswithholding(e)}
            sumtaxwithholding={(e) => reswithholding(e)}
          />
        </TabPanel>
      </Box>
      <Divider />
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}></Grid>
          <Grid item xs={2} sx={{ mt: 1 }}>
            <DefaultButton title={"ตกลง"} onClick={(e) => onSubmit(e)} />
          </Grid>
          <Grid item xs={4}>
            <CustomInput
              label={"รวมยอดภาษี ณ ที่จ่าย "}
              id="sumprice"
              onBlur={(e) => console.log(e)}
              inputType={"number"}
              defaultValue={withholdingdefaultValue.toFixed(2)}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

Receiptwithholding.propTypes = {
  docnoData: PropTypes.array,
  userData: PropTypes.array,
  mainrowsData: PropTypes.array,
};
